export enum EventTypeEnum {
  Login = 1,
  Search = 2,
  AddCart = 3,
  RemoveCart = 4,
  Order = 5,
  ViewOrderHistory = 6,
  ViewDiscount = 7,
  ViewLatestNews = 8,
  ViewNewProducts = 9,
  Logout = 10
}
